// Channels come from masterdata — never a hardcoded grabfood/grabmart list.
import { useSalesChannelsForBranchQuery } from "@/generated/graphql";
import { useMemo } from "react";

export interface SalesChannelItem {
	salesChannelID: string;
	salesChannelName: string;
	salesChannelType: string;
	useCategoryMap: boolean;
}

export const useSalesChannelOptions = () => {
	const options = useMemo(
		() => ({
			variables: {
				qop: {
					pagination: { page: 1, pageSize: 100, withCount: false },
					filters: { isActive: true },
				},
			},
			requestPolicy: "network-only" as const,
			context: { suspense: false },
		}),
		[],
	);

	const [result] = useSalesChannelsForBranchQuery(options);
	const items = result.data?.salesChannels.items ?? [];

	return {
		items,
		options: items.map((c) => ({
			value: c.salesChannelID,
			label: c.salesChannelName,
		})),
		nameByID: new Map(items.map((c) => [c.salesChannelID, c.salesChannelName])),
		typeByID: new Map(items.map((c) => [c.salesChannelID, c.salesChannelType])),
		fetching: result.fetching,
	};
};
